// Modules
import { CommonModule } from '@angular/common';
import { IconModule } from '../../directives/icon/icon.module';
import { StoreModule } from '@ngrx/store';
// NgRx reducers
import { PAGE_ERROR_MESSAGE_STATE_SLICE_KEY, pageErrorMessage } from './state/page-error-message.reducer';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
export class PageErrorMessageModule {
}
PageErrorMessageModule.ɵfac = function PageErrorMessageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageErrorMessageModule)(); };
PageErrorMessageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PageErrorMessageModule });
PageErrorMessageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule, IconModule, StoreModule.forFeature(PAGE_ERROR_MESSAGE_STATE_SLICE_KEY, pageErrorMessage)] });
